import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import MuiStepper from '@mui/material/Stepper';

import './Stepper.scss';

export interface StepperProps {
    /**
     * The current active step (zero-indexed)
     */
    activeStep: number;
    /**
     * Array of step names/labels
     */
    steps: string[];
}

/**
 * Stepper component for multi-step workflows
 *
 * This component provides a visual indicator of progress through a multi-step process.
 * It's built on top of Material-UI's Stepper but adapted to our design system.
 *
 * @param activeStep - The current active step (zero-indexed)
 * @param steps - Array of step names/labels to display
 *
 * @example
 * ```tsx
 * <Stepper
 *   activeStep={1}
 *   steps={['Select Product', 'Configure', 'Review']}
 * />
 * ```
 */

const Stepper = ({ activeStep, steps }: StepperProps) => {
    return (
        <MuiStepper className="stepper" alternativeLabel activeStep={activeStep}>
            {steps.map((stageName) => {
                return (
                    <Step key={stageName}>
                        <StepLabel>{stageName}</StepLabel>
                    </Step>
                );
            })}
        </MuiStepper>
    );
};

export default Stepper;
